import React from 'react';
import Select from 'react-select'
import GCFLine from './GCF/GCF_Line'
import TCFLine from './TCF/TCF_Line'

var TCF_Area1 = require('../Resources/Data/TCF_Area_1.json')
var TCF_Area2 = require('../Resources/Data/TCF_Area_2.json')
var TCF_Area3 = require('../Resources/Data/TCF_Area_3.json')
var TCF_Area4 = null

const optionsAG = [
  { value: 'Area2', label: 'Département' },
  { value: 'Area3', label: 'Canton' },//District
  { value: 'Area4', label: 'Communauté de communes' },//City
  { value: 'Area5', label: 'Commune' }//Town
]

const optionsAR1 = [
  { value: 'Area1', label: 'Région' },
  { value: 'Area2', label: 'Département' },
  { value: 'Area3', label: 'Canton' },
  { value: 'Area4', label: 'Communauté de commune' },
  { value: 'Area5', label: 'Commune' }
]
/*
const optionsNT = [
  { value: 'France', label: 'France' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Switzerland', label: 'Switzerland' }
]*/

function ExtractAG2(ar, ag) {
  var optionsAR = []
  var temp
  switch (ar) {
    case "Area1":
      temp = TCF_Area1.Area_1
      break;
    case "Area2":
      temp = TCF_Area2.Area_2
      break;
    case "Area3":
      temp = TCF_Area3.Area_3
      break;
    case "Area4":
      temp = TCF_Area3.Area_4
      break;
    case "Area5":
      temp = TCF_Area4.Area_5
      break;
    default :
      temp = TCF_Area1.Area_1
      break;
  }
  if (temp) temp = temp.find((element) => { return (element.name === global.name_area) })
  if(temp)
  switch (ag) {
    case "Area2":
      if (temp.Aggregation.area_2)
        temp.Aggregation.area_2.forEach(element => {
          optionsAR.push({ value: element.name, label: element.name })
        })
      break;
    case "Area3":
      if (temp.Aggregation.area_3)
        temp.Aggregation.area_3.forEach(element => {
          optionsAR.push({ value: element.name, label: element.name })
        })
      break;
    case "Area4":
      if (temp.Aggregation.area_4)
        temp.Aggregation.area_4.forEach(element => {
          optionsAR.push({ value: element.name, label: element.name })
        })
      break;
    case "Area5":
    default:
      if (temp.Aggregation.area_5)
        temp.Aggregation.area_5.forEach(element => {
          optionsAR.push({ value: element.name, label: element.name })
        })
      break;

  }

  return optionsAR;
}

function ExtractAR(ar) {
  var optionsAR = []
  var temp
  switch (ar) {
    case "Area1":
      temp = TCF_Area1.Area_1
      break;
    case "Area2":
      temp = TCF_Area2.Area_2
      break;
    case "Area3":
      temp = TCF_Area3.Area_3
      break;
    case "Area4":
    default:
      temp = TCF_Area3.Area_4
      break;
  }
  if (temp) {
    temp.forEach((element) => {
      optionsAR.push({ value: element.name, label: element.name })
    })
  }
  return optionsAR

}

export default class Stats extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.ag = global.ag
    this.state.ar = global.ar
  }
  handleChangeNT = selectedOption => {
    global.nat = selectedOption.value
    this.setState(
      { selectedOption }
    );
  };

  handleChangeAR1 = selectedOption => {
    global.ar = selectedOption.value
    //this.state.ar = global.ar
    this.setState(
      { selectedOption }
    );
  };

  handleChangeAG1 = selectedOption => {
    global.ag = selectedOption.value
    //this.state.ag = selectedOption.value
    this.setState(
      { selectedOption }
    );
  };

  handleChangeAR = selectedOption => {
    global.name_area = selectedOption.value
    this.setState(
      { selectedOption }
    );
  };
  handleChangeAG = selectedOption => {
    global.name_ag = selectedOption.value
    this.setState(
      { selectedOption }
    );
  };

  render() {
    return (
      <div className="layout">
        <h1>Statistiques</h1>
        <div className="selector">
          <div className="selector dual">
            <h2>Zone</h2>
            <Select options={optionsAR1} value={optionsAR1.find(element => element.value === global.ar)} onChange={this.handleChangeAR1}/>
          </div>
          <div className="selector dual">
            <h2>Agrégat</h2>
            <Select options={optionsAG} value={optionsAG.find(element => element.value === global.ag)} onChange={this.handleChangeAG1} />
          </div>
        </div>
        <div className="selector">
          <div className="selector dual">
            <Select options={ExtractAR(global.ar)} value={ExtractAR(global.ar).find(element => element.value === global.name_area)} onChange={this.handleChangeAR} />
          </div>
          <div className="selector dual">
            <Select options={ExtractAG2(global.ar, global.ag)} value={ExtractAG2(global.ar, global.ag).find(element => element.value === global.ag)} onChange={this.handleChangeAG} />
          </div>
        </div>
        <GCFLine ag={this.state.ag} ar={this.state.ar} />
        <TCFLine ar={global.ar} ag={this.state.ag} />
      </div>
    );
  }
};
